/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Common_Contactcta1Inputs */

const ja_playdata_common_contactcta1 = /** @type {(inputs: Playdata_Common_Contactcta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const en_playdata_common_contactcta1 = /** @type {(inputs: Playdata_Common_Contactcta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

/**
* | output |
* | --- |
* | "Contact Us" |
*
* @param {Playdata_Common_Contactcta1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_common_contactcta1 = /** @type {((inputs?: Playdata_Common_Contactcta1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Common_Contactcta1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_common_contactcta1(inputs)
	return en_playdata_common_contactcta1(inputs)
});
export { playdata_common_contactcta1 as "playdata_common_contactCta" }